import classnames from "classnames";
import React from "react";
import environment from "web/script/modules/environment";
import BackFilterItem from "web/react/components/back-filter-item/back-filter-item";
import CheckboxFilterItem from "web/react/components/checkbox-filter-item/checkbox-filter-item";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption } from "web/types/universal-filters";
import { FilterUXVariant } from "web/react/components/feeds-filters/filter-variants";
import styles from "./category-filter-item.css";

interface CategoryFilterItemProps extends StandardFilterProps {
    item: CategoryFilterOption;
    siblingOpen?: boolean;
    goBackString: string;
}

function CategoryFilterItem({
    item,
    pendingFilterInfo,
    siblingOpen,
    goBackString,
    onClick,
}: CategoryFilterItemProps): JSX.Element {
    const filterVariant = environment.getFeature("mg_test_filter_ux");
    const open = pendingFilterInfo.getChecked(item);

    // This url can change each time the user clicks something
    let expandableId = `category_filter_item_${item.url}`;
    return (
        <li
            className={classnames(styles.filterGroup, {
                [styles.lessMarginLeft]:
                    filterVariant == FilterUXVariant.HIDE_CATEGORY_SIBLINGS &&
                    item.children.length == 0,
            })}
        >
            <CheckboxFilterItem
                {...{
                    item,
                    pendingFilterInfo,
                    onClick,
                    siblingOpen,
                }}
                ariaControls={expandableId}
                hasChildren={item.children.length > 0}
            />
            {item.children.length > 0 && (
                <ol
                    className={classnames(styles.subOptionsGroup, {
                        [styles.open]: open,
                        [styles.closed]: !open,
                        [styles.lessPaddingLeft]:
                            filterVariant == FilterUXVariant.HIDE_CATEGORY_SIBLINGS,
                    })}
                    id={expandableId}
                >
                    {item.children.map((item) => {
                        return (
                            <li key={item.value}>
                                <CheckboxFilterItem
                                    {...{
                                        item,
                                        pendingFilterInfo,
                                        onClick,
                                    }}
                                    isSmallItem={true}
                                />
                            </li>
                        );
                    })}
                </ol>
            )}
            {filterVariant == FilterUXVariant.OTHER_BUTTON_AVAILABLE && item.children.length > 0 && (
                <div className={classnames({ [styles.open]: open, [styles.closed]: !open })}>
                    <BackFilterItem
                        title={goBackString}
                        {...{
                            item,
                            pendingFilterInfo,
                            onClick,
                            siblingOpen,
                        }}
                        ariaControls={expandableId}
                        hasChildren={item.children.length > 0}
                    />
                </div>
            )}
        </li>
    );
}

export default CategoryFilterItem;
